export default "__VITE_ASSET__CEQKmY7y__"